
const columns = () => {
  return [
    {
      title: '组织名称',
      name: 'name',
      tableItem: {
        width: 200
      },
      searchItem: {
      }
    },
    {
      title: '组织编码',
      name: 'code',
      tableItem: {
        width: 250
      },
      searchItem: {
      }
    },
    {
      title: '组织类型',
      name: 'organizationNodeCategoryName',
      tableItem: {
        width: 260
      },
    },
    {
      title: '组织状态',
      name: 'state',
      dict: [
        { code: 1, codeName: '有效' },
        { code: 0, codeName: '无效' },
      ],
      tableItem: {
        width: 100
      }
    }
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'organization/pageListByCond',
    ...api
  }
}

const dealer = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(),
    tableApi: tableApi(api)
  }
}

export default dealer
